import { format, isMatch, isValid, parse, parseISO } from 'date-fns';

export const minCalendarMonth = new Date(1900, 0);

export const maxCalendarMonth = new Date(2100, 11);

export const storedDateFormat = 'yyyy-MM-dd';

export const displayDateFormat = 'MM/dd/yyyy';

export const displayDateTimeFormat = 'MM/dd/yyyy hh:mm aa';
const acceptedDisplayDateTimeFormats = ['MM/dd/yyyy h:mm aa', 'MM/dd/yyyy hh:mm aa'];

function normalizeMeridiem(value: string): string {
  return value.replace(/\s(am|pm)$/i, (match) => match.toUpperCase());
}

export function parseExactDate(value: string, dateFormat: string): Date | undefined {
  if (!isMatch(value, dateFormat)) {
    return undefined;
  }

  const parsedDate = parse(value, dateFormat, new Date());

  return isValid(parsedDate) ? parsedDate : undefined;
}

export function parseStoredDateValue(value: string | undefined): Date | undefined {
  if (!value) {
    return undefined;
  }

  const [datePart] = value.split('T');

  return parseExactDate(datePart, storedDateFormat);
}

export function isStoredDateValue(value: string): boolean {
  const [datePart] = value.split('T');

  if (!parseExactDate(datePart, storedDateFormat)) {
    return false;
  }

  return !value.includes('T') || isValid(parseISO(value));
}

export function formatStoredDate(date: Date): string {
  return format(date, storedDateFormat);
}

export function formatDisplayDate(date: Date): string {
  return format(date, displayDateFormat);
}

export function parseDisplayDate(value: string): Date | undefined {
  return parseExactDate(value, displayDateFormat);
}

export function parseStoredDateTimeValue(value: string | undefined): Date | undefined {
  if (!value) {
    return undefined;
  }

  if (value.includes('T')) {
    const parsedDate = parseISO(value);

    return isValid(parsedDate) ? parsedDate : undefined;
  }

  return parseStoredDateValue(value);
}

export function isStoredDateTimeValue(value: string): boolean {
  return value.includes('T') ? isValid(parseISO(value)) : !!parseStoredDateValue(value);
}

export function formatDisplayDateTime(date: Date): string {
  return format(date, displayDateTimeFormat);
}

export function parseDisplayDateTime(value: string): Date | undefined {
  const normalizedValue = normalizeMeridiem(value.trim());

  for (const dateFormat of acceptedDisplayDateTimeFormats) {
    const parsedDate = parseExactDate(normalizedValue, dateFormat);

    if (parsedDate) {
      return parsedDate;
    }
  }

  return undefined;
}
